import { MenuItem, Select, Box } from "@mui/material";
import { useI18n } from "../i18n-context";

export function LanguageSwitcher() {
  const { locale, setLocale } = useI18n();

  return (
    <Box>
      <Select
        value={locale}
        onChange={(e) => setLocale(e.target.value as "en" | "it")}
        variant="outlined"
        size="small"
        sx={{
          boxShadow: "none",
          ".MuiOutlinedInput-notchedOutline": { border: 0 },
        }}
      >
        <MenuItem value="en" sx={{ display: "flex", justifyContent: "center" }}>
          🇬🇧
        </MenuItem>
        <MenuItem value="it" sx={{ display: "flex", justifyContent: "center" }}>
          🇮🇹
        </MenuItem>
      </Select>
    </Box>
  );
}
